enum ClinicalNotesMsgStatus {
  DEACTIVATED = 'deactivated',
}

const CLINICAL_NOTES_MSG_COOKIE_KEY = 'clinical-notes-msg';

export {
  CLINICAL_NOTES_MSG_COOKIE_KEY,
  ClinicalNotesMsgStatus,
}
